import { render, staticRenderFns } from "./addFund.vue?vue&type=template&id=5a72a692&scoped=true"
import script from "./addFund.vue?vue&type=script&lang=js"
export * from "./addFund.vue?vue&type=script&lang=js"
import style0 from "./addFund.vue?vue&type=style&index=0&id=5a72a692&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a72a692",
  null
  
)

export default component.exports